export default Object.freeze({
    MONTHLY: 'MONTHLY',
    /** @deprecated Prefer ANNUAL for PLAN-engine API payloads */
    ANNUALLY: 'ANNUALLY',
    ANNUAL: 'ANNUAL',
})
